import {BasePage} from "../../types/PageTypes";
import {Redirect, Switch} from "react-router-dom";
import PageHeader from "../shared-components/page-header/PageHeader";
import React from "react";
import { t } from "i18next";

const AgencyReportsPage = (props: BasePage) => {
    return (
        <Switch>
            {props.children}
            <PageHeader
                title={t("app.main.layout.subTopBar.title10", " Agency Raports")}
                  desc={t("app.main.agency.agentsList.agencyreport.desc","History of reports that agents have done - Click the Payment or Provision to see the Reports that has been done.",)}
            />
            <Redirect to='/agency-reports'/>
        </Switch>
    )
}

export default AgencyReportsPage;